window.setListrakRemoveCookieListener = () => {
    const checkoutBtn = document.getElementById('CartDrawer-Checkout')
    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function() {
            document.cookie = "ltk-loyalty-offer=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.tartecosmetics.com;";
        })
    }
}

document.addEventListener('cartdrawer:constructed', window.setListrakRemoveCookieListener());

